// extracted by mini-css-extract-plugin
export default {"actionBtn":"DashboardDataDisplay_actionBtn__3hv-r"};